import { BillingTransferRequest } from "@common/dto/billing/transfer-request.dto";

export enum BillingTransferRequestStatus {
    PENDING = "pending",
    ACCEPTED = "accepted",
    REJECTED = "rejected",
    COMPLETED = "completed",
    CANCELED = "canceled",
    DECLINED = "declined",
}

export type BillingTransferRequestResolution =
    | BillingTransferRequestStatus.ACCEPTED
    | BillingTransferRequestStatus.REJECTED;

export enum BillingTransferRequestType {
    WORKSPACE_TO_ORGANIZATION = "workspace_to_organization",
    ORGANIZATION_TO_WORKSPACE = "organization_to_workspace",
    ORGANIZATION_INITIATED = "organization_initiated",
}

export const TRANSFER_REQUEST_ROUTE = "transfer-requests";

export function getBillingTransferRequestResolutionUrl(
    request: BillingTransferRequest,
    resolution: BillingTransferRequestResolution,
) {
    return `${TRANSFER_REQUEST_ROUTE}/${request.code}/${resolution}`;
}

// must match the getter result
export const billingTransferRequestRoute = `/${TRANSFER_REQUEST_ROUTE}/:code/:resolution`;
